import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const Registration = ({
    registrationIdsSelected,
    onUpdateRegistrationIdSelected
}) => {
    const [recordsRegistration, setRecordsRegistrations] = useState(null);

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        marginRight: '5px',
        minWidth: 'calc(25% - 15px)',
        maxWidth: 'calc(25% - 15px)'
    }

    useEffect(() => {
        getRegistrationRecords()
    }, []);

    async function getRegistrationRecords() {
        const parameters = { dsItem: '' }
        const registrations = await ExecuteAxios.api('get', `/general-records/get-general-records-grid/`, { params: parameters })
        if (registrations && registrations.length > 0) {
            onUpdateRegistrationIdSelected([registrations[0].id])
        }
        setRecordsRegistrations(registrations)
        RemoveIdsNotFound.remove(registrations, onUpdateRegistrationIdSelected, registrationIdsSelected)
    }

    return (
        <Panel
            titlePage='Cadastros gerais'
            style={userControlPanelStyle}
            canEdit={false}
            canNewRecord={false}
            canDelete={false}
            canViewCRUD={true}
            readOnly={true}
            recordsSelected={registrationIdsSelected}
            viewOnlyOneRecordCRUD={true}
            className={'main-modal config-registration'}
        >
            <LoadingIndicator loaded={recordsRegistration}>
                <PanelListDefault
                    onUpdateIdSelected={onUpdateRegistrationIdSelected}
                    idsSelected={registrationIdsSelected}
                    data={recordsRegistration}
                />
            </LoadingIndicator>
        </Panel>
    );
};

export default Registration;


